class Email {
    constructor(email) {
        this.email = email;
    }

    validar() {
        if (!this.email) {
            return false;
        }
        return !(this.email && !this.esEmail(this.email));
    }

    esEmail() {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(this.email);
    }
}

export default Email;
